export function getRootAppElement(): HTMLDivElement {
  const el = document.getElementById('app') as HTMLDivElement;

  if (!el) {
    throw new Error('Root element not found');
  }

  return el;
}

export function getRootErrorElement(): HTMLDivElement {
  const el = document.getElementById('global-error') as HTMLDivElement;

  if (!el) {
    throw new Error('Root Error element not found');
  }

  return el;
}

export function getRootSkeletonAppElement(): HTMLDivElement | null {
  const el = document.getElementById('skeleton-app') as HTMLDivElement | null;

  return el;
}
